import React, { useState, useEffect, useContext,useMemo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { fetchPackage } from './Api';
import { useParams, useHistory, Link } from 'react-router-dom';
import { Contextone } from './Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import logo from '../images/aaryaottlogo.png';
import Cookies from 'js-cookie';
import globalSetting from "../configuration.js";
import Slideshow from "./Slideshow";
import { fetchBanner, fetchSectionList } from "./Api";
import Footer from './Footer/Footer.jsx';
import rent from "../images/rent.png";

import bgImg from '../images/login-backgrd.jpeg';
import check from '../images/blue.png';
import Backvideo from '../videos/sliding image.mp4';

const Subscription = () => {
    const { urls, movie, encode } = useParams();
    const [isBanner, setBanner] = useState();
    const [page, setPage] = useState([]);
    const [pages, setPages] = useState([]);
    const [couponOption, setCouponOption] = useState(false);
    const [couponNo, setCouponNo] = useState("");
    const [couponErr, setCouponError] = useState("");
    const [isPackageName, setPackageName] = useState('');
    const [isPackageIdd, setPackageIdd] = useState(0);
    const [isNewAmt, setNewAmt] = useState(0);
    const [paymentOptions, setPaymentOptions] = useState({});
    const [userSubscribe, setUserSubscribe] = useState([]);

    const counterContext = useContext(Contextone);
    const logo = counterContext.isLogo
    const uid = localStorage.getItem('userid');
    const uphone = localStorage.getItem('userPhone');
    const uemail = localStorage.getItem('userEmail');
    const countercontext = useContext(Contextone);
    const url = countercontext.isDomain;
    const apiUrl = `https://${url}`;
    const apiLogo = countercontext.isLogo
    const history = useHistory();
    const userid = Cookies.get('userid');

    if (!uid) {
        Cookies.set('loc', history.location.pathname)
    }
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchBanner(apiUrl,0,1,0);
                setBanner(data.result);
            } catch (error) {
                console.error('Error:', error);
            }
        };
        fetchData();
    }, [uid]);
          
    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchPackage(apiUrl);
                setPage(data.result[1]);
                setPages(data.result);
            } catch (error) {
                console.error('Error:', error);
            }
        };
        fetchData();
    }, [uid]);

    useEffect(() => {
        const fetchPaymentOptions = async () => {
            try {
                const response = await fetch(apiUrl + '/api/get_payment_option', {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    }
                });
                const data = await response.json();
                setPaymentOptions(data.result);
            } catch (error) {
                console.error('Error:', error);
            }
        };
        fetchPaymentOptions();
    }, []);

    const fetchSubscriptionList = async () => {
        if(uid){
            try {
                const response = await fetch(apiUrl + '/api/subscription_list', {
                    method: 'POST',
                    body: JSON.stringify({ user_id: uid }),
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    }
                });
                const data = await response.json();
                setUserSubscribe(data.result);
            } catch (error) {
                console.error('Error fetching subscription list:', error);
            }
        }
        
    };
    
    useEffect(() => {
        fetchSubscriptionList();
    }, [uid]);

    const addTransaction = async (amount, payId, packageId, name) => {
        try {
            const response = await fetch(apiUrl + '/api/add_transaction', {
                method: 'POST',
                body: JSON.stringify({ user_id: uid, package_id: packageId, description: name, amount: amount, payment_id: payId, currency_code: "", unique_id: "" }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                }
            });
            const data = await response.json();
            fetchSubscriptionList();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const addOrderId = async (amount, email, contact, name, packageId) => {
        try {
            const response = await fetch(apiUrl + '/api/create-order', {
                method: 'POST',
                body: JSON.stringify({
                    amount: amount,
                    currency: "INR",
                    name: name,
                    mobile: contact,
                    email: email
                }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                }
            });
            const data = await response.json();
            const oId = data.status;
            if (oId === 200 || oId === "" || oId === null) {
                handlePayment(amount, packageId, name, data.result.id);
                setCouponOption(false)

            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const addCoupon = async (amt, couponDetail, packageId,) => {
        try {
            const response = await fetch(apiUrl + '/api/apply_coupon', {
                method: 'POST',
                body: JSON.stringify({
                    user_id: userid,
                    apply_coupon_type: "1",
                    unique_id: couponDetail,
                    package_id: packageId,
                }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                }
            });
            const data = await response.json();
            if (data.message === 'Coupon Code Wrong.') {
                setCouponError('Coupon Code Wrong.');
                setNewAmt(amt);
            } else {
                setNewAmt(data.result.discount_amount);
                setCouponError("Coupon applied")
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handlePayment = async (amount, packageId, name, orderId) => {
        const razorpayOptions = paymentOptions.razorpay;
        if (!razorpayOptions) {
            console.error('Razorpay options not loaded');
            return;
        }

        const key = razorpayOptions.is_live === "1" ? razorpayOptions.live_key_1 : razorpayOptions.test_key_1;

        try {
            const options = {
                key: key,
                amount: amount * 100,
                currency: "INR",
                name: name,
                order_id: orderId,
                packageId: packageId,
                image: apiLogo,
                prefill: {
                    userId: uid,
                    email: uemail,
                    contact: uphone,
                },
                autocapture: 1,
                theme: {
                    color: "#3399cc"
                },
                handler: function (response) {
                    addTransaction(amount, response.razorpay_payment_id, packageId, name);
                }

                
            };
           
            const rzp1 = new window.Razorpay(options);
            rzp1.open();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        if(uid){
            userSubscribe.forEach(mtype => {
                if (mtype.user_id == uid) {
                    countercontext.isPremium = true;
                    if(encode){
                        history.push(`/${urls}/${movie}/${encode}`)
                    }
                     
                }
            });
        }
        
    }, [userSubscribe]);


    const handlePaymentBackBtn = () => {
        setCouponOption(false)
        setCouponNo('')
        setCouponError("")
    }

    const closeCouponBox = (isNewAmt, isPackageName, isPackageIdd) => {
        withoutRazorpay()
        addTransaction(isNewAmt, null, isPackageIdd, isPackageName)
     

    }
    const withoutRazorpay = () => {
        setCouponOption(false)
        setCouponNo('')
    }

   
    const [activeId, setActiveId] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    
    const handleClick = (time, id) => {
        setActiveId(id);
        setSelectedPlan((prevPlan) => {
            if (prevPlan && prevPlan.time === time && prevPlan.id === id) {
                return null; 
            }
            return { time, id }; 
        });
    };
    return (
        <div className='subscription-page'>
            <div className="top-left-button">
                <button onClick={() => history.goBack()} style={{ background: 'none', border: 'none', fontSize: '24px', color: '#000', cursor: 'pointer', }}>
                    <FontAwesomeIcon icon={faArrowLeft} style={{ color: 'white',position: 'relative',}} />
                </button>

                <img src={logo} alt="Logo" className="subscription-logo1" />    

            </div>
            <div className='subscriptionPackage'>  
            <div className='left-side'>    
                {/* <h3 className='subsheading'   style={{color:'white', width:'32%' ,fontSize:'35px',paddingLeft:'90px'}}>Subscribe now and start streaming</h3> */}
                <div className='subscription-content'>
                    <div className="bannersubs">
                        <img src={bgImg} alt="Background" className="background-image-subs" />
                    </div>
                    
                    <div className='package-data'>  
                    <div className='package-content'>
                        {Array.isArray(page.data) && page.data.map((itm, i) => (
                            <li className='list-li' style={{color:'white'}} key={i}>{itm.package_key}</li>
                        ))}
                    </div>
                    <div className="card-deck-wrapper">
                        {pages.map((mtype) => {
                            const isSubscribed = userSubscribe.some(subscription => subscription.package_id === mtype.id);
                            const anyPageSubscribed = userSubscribe.length > 0;
                            return(
                                <div key={mtype.id} className="card-container">
                                    <div className={`card mb-4 shadow-sm black-card ${activeId === mtype.id ? 'active' : ''}`}
                                            style={{backgroundColor: activeId === mtype.id ? 'rgb(42 97 117 / 13%)' : 'transparent',}}>   
                                            <div className="card-header-custom red-text">
                                                <div className="my-0 font-weight-normal package-head">{mtype.name}</div>
                                            </div>
                                            <div className="bodysubs">
                                                {mtype.data.slice(0, -1).map((content, key) => (
                                                    <div key={key}>
                                                        <ul className="list-unstyled card-list">
                                                            <li className="last-item">{content.package_value == 1 ? 'Yes' : content.package_value == 0 ? 'NO' : content.package_value}</li>
                                                        </ul>
                                                    </div>
                                                ))}
                                                {mtype.data.length > 0 && (
                                                    <div>
                                                        <ul className="list-unstyled card-list">
                                                            <li className="last-item">{mtype.data.at(-1)?.package_value == 1 ? 'Yes' : mtype.data.at(-1)?.package_value == 0 ? 'NO' : mtype.data.at(-1)?.package_value}</li>
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                    </div>

                                    <div className="car">
                                        <button
                                            className="plan_button"
                                            onClick={() => handleClick(mtype.time, mtype.id)}
                                            style={{
                                                zIndex: '1',
                                                borderColor:selectedPlan?.id === mtype.id ? 'White' : 'grey',
                                            }}
                                            >
                                            <span className='plans_price'>₹ {mtype.price}</span>
                                            {/* <span>{` / ${mtype.time}${mtype.type}`}</span> */}
                                        </button>
                                    </div>

                                    <div className="choose_plan_container">
                                    {!isSubscribed ?(
                                        <button type="button" className="subscription_button btn btn-lg btn-block planBtn" style={{ backgroundColor:selectedPlan?.id === mtype.id ? 'white' : '',color:selectedPlan?.id === mtype.id ? 'black': '',}}
                                        {...(anyPageSubscribed ? {onClick: ()=>{
                                            alert("Already Subscribed");
                                        }} : { onClick: () => {
                                            if (uid) {
                                                const newAmount = mtype.price;
                                                const packageName = mtype.name;
                                                const packageId = mtype.id;
                                                setNewAmt(newAmount);
                                                setPackageName(packageName);
                                                
                                                setPackageIdd(packageId);
                                                setCouponOption(true);  
                                            } else {
                                                history.push('./login');
                                            }
                                        }})} >
                                    
                                        Choose Plan
                                        </button>
                                    ):(
                                        <div className="subscription_button btn btn-lg btn-block planBtn" style={{backgroundColor:'#d1e7dd', color: 'black', fontWeight: '600'}}>
                                            Subscribed!
                                        </div>
                                    )}
                                    
                                    </div>
                                </div>
                            )
                            
                        })}
                        
                    </div>
                    </div>
                </div>
            </div>   
        </div>     
            {couponOption && (
                <>
                    <div className="blur-background">

                        <div className="video-container">
                            <video autoPlay muted loop className="background-video">
                                <source src={Backvideo} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                            <div className="payment-details">
                                <div>
                                    <button className="back-button-subscription" onClick={handlePaymentBackBtn}>&larr;</button>
                                    <Link to={"/"}>
                                        <img className="COUPONLOGO" src={logo} alt="Logo" />
                                    </Link>
                                    
                                </div>
                                <div className='coupon-content'>
                                    <div className="coupon-section">
                                        <input
                                            type="text"
                                            value={couponNo}
                                            onChange={(e) => setCouponNo(e.target.value)}
                                            placeholder="Enter coupon code..."
                                        />
                                        <button
                                            className="apply-button"
                                            onClick={() => addCoupon(isNewAmt, couponNo, isPackageIdd)}
                                            style={{font: 'bold'}}
                                            >
                                                Apply Coupon Code
                                        </button>
                                        <div className="payment-methods">
                                            {isNewAmt ? (
                                                <div className="pay-with">
                                                    <button
                                                        className="razorpay-button"
                                                        onClick={() => addOrderId(isNewAmt, uemail, uphone, isPackageName, isPackageIdd)}
                                                        >
                                                        <div className='text'>
                                                    <img className="paybuttonicon" src ={rent} alt="" 
                                                        />
                                                        {isNewAmt}.00
                                                        </div>
                                                    </button>
                                                </div>
                                            ) : closeCouponBox(isNewAmt, isPackageName, isPackageIdd)}
                                        </div>
                                        {couponOption && couponErr && (
                                            <div>
                                                <span className="error-message">{couponErr}</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className='coupon_slideshow'><Slideshow  data={isBanner}  bannervisible={true} istype="video" /></div>  
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </>
            )}
        </div>
    );
}

export default Subscription;